const globalStyleIdLabel = 'gs-text-main-label';
const globalStyleIdText = 'gs-text-main-input-number';
const defaultSelectorLabel = {
  selector: '#{mID} label',
};
const defaultSelectorText = {
  selector: '#{mID} .gf_product-quantity',
};
export default {
  defaultClass: 'gf_gs_ct',
  settingGroups: {
    [globalStyleIdLabel]: {
      'label-font-weight': {
        ...defaultSelectorLabel,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'label-font-size': {
        ...defaultSelectorLabel,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'label-line-height': {
        ...defaultSelectorLabel,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      // "label-color": {
      //   ...defaultSelectorLabel,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      'label-font': {
        ...defaultSelectorLabel,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
    [globalStyleIdText]: {
      fontWeight: {
        ...defaultSelectorText,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelectorText,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      // color: {
      //   ...defaultSelectorText,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      font: {
        ...defaultSelectorText,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const P_QUANTITY_SETTING = [
  {
    gsId: globalStyleIdLabel,
    gsSettingGroup: 'Show Label',
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
    isSettingAdvand: true,
  },
  {
    gsId: globalStyleIdText,
    gsSettingGroup: 'Input Number',
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
  },
];
